<template>
  <span>
    <span
      v-show="messageCount > 0"
      class="btn-tiny-circle btn-orange"
    >
      {{ messageCount }}
    </span>
  </span>
</template>

<script>

import { mapState } from "vuex";

export default {
  name: "SupportNotificationsShow",
  props: {
    count: Number,
  },
  computed: {
    ...mapState({
      messageCount: state => state.support.messageCount
    }),
  },
};
</script>
